import { TFunction } from 'i18next'
import { nameOf } from '../../../../utils/functions/ReflectionUtil'
import { Order } from '../../../../core/models/entities/Order'
import { enviroment } from '../../../../enviroment'
import { ColumnField } from '../../../components/GenericTable/SubComponents/Column'

export function orderColumnsConfig(t: TFunction) {
  // Ret levering (flag REACT_APP_RET_LEVERING_ENABLED): the delivery-date
  // column is renamed to "Expected delivery" (the value has ALWAYS been
  // Order.LatestDelivery, which the API's nightly SyncShipmentDatesFromNavAsync
  // overwrites with NAV's ExpectedShipmentDate - so the data already IS the
  // estimated shipment date; only the label changes), and a T&T column with
  // the tracking link is added. Flag off = exactly today's columns.
  const retLevering = enviroment.retLeveringEnabled

  const columns: ColumnField[] = [
    {
      value: nameOf<Order>(x => x.orderNumber),
      canSortBy: true,
      displayValue: t('orderListDetails.colOrderNo'),
      weight: 1
    },
    {
      value: nameOf<Order>(x => x.requisitionNumber),
      canSortBy: true,
      displayValue: t('orderListDetails.colRequisitionNumber'),
      weight: 1.5
    },
    {
      value: nameOf<Order>(x => x.organization),
      canSortBy: true,
      displayValue: t('customer'),
      weight: 2
    },
    {
      value: nameOf<Order>(x => x.organization.contactPerson),
      canSortBy: true,
      displayValue: t('orderListDetails.colContactPerson'),
      weight: 0
    },
    {
      value: nameOf<Order>(x => x.status),
      canSortBy: true,
      displayValue: t('status'),
      weight: 1.5
    },
    {
      value: nameOf<Order>(x => x.placedAtUtc),
      canSortBy: true,
      displayValue: t('orderListDetails.colOrderDate'),
      weight: 1
    },
    {
      value: nameOf<Order>(x => x.latestDelivery),
      canSortBy: true,
      displayValue: retLevering
        ? t('orderListDetails.colExpectedDelivery')
        : t('orderConfirmation.estShipmentDate'),
      weight: 1.4
    }
  ]

  if (retLevering) {
    columns.push({
      value: nameOf<Order>(x => x.trackingNo),
      // The list endpoint doesn't support sorting by tracking number.
      canSortBy: false,
      displayValue: t('orderListDetails.colTrackTrace'),
      weight: 1
    })
  }

  columns.push({
    value: 'actions',
    canSortBy: false,
    displayValue: t('action'),
    weight: 1.2
  })

  return columns
}
